<script lang="ts">
	import ContactUs from "./components/ContactUs.svelte";
	import { allJournalists, tipsRedaksjonen } from "./journalists";
	import Select from "svelte-select";
	import type { Config } from "./types";

	let isCopyDone = false;
	let viewJournalistSettings = false;
	let viewPhone = true;
	let viewEmail = true;
	let viewImages = true;
	let viewKryptert = false;
	let allJournalistPromise = allJournalists();

	const defaultText =
		"Har du innspill, eller egne erfaringer om dette temaet - da vil vi gjerne høre fra deg!";
	let config: Config = {
		title: "Hallo 👋",
		subtitle: "",
		text: defaultText,
		thanks: "Vennlig hilsen",
		viewImages,
		viewEmail,
		viewPhone,
		viewKryptert,
		journalists: [tipsRedaksjonen],
	};

	$: codeToCopy =
		`<link rel="stylesheet" href="https://editorial.aftenbladet.no/2022/sa-tips-kontakt-oss/build/bundle.css"/>
	<script defer src="https://editorial.aftenbladet.no/2022/sa-tips-kontakt-oss/build/bundle.js"><` +
		`/script>
		<section class="sa-contact-us" data-config="` +
		encodeURI(JSON.stringify(config)) +
		`"></section>`;

	const addJournalist = () => {
		viewJournalistSettings = true;
		config = {
			...config,
			journalists: [
				...config.journalists,
				{ name: "", image: "", email: "", phone: "" },
			],
		};
	};
	const removeJournalist = (index: number) => {
		config = {
			...config,
			journalists: config.journalists.filter((_, i) => i !== index),
		};
	};

	const copyCode = () => {
		navigator.clipboard.writeText(codeToCopy).then(() => {
			isCopyDone = true;
			setTimeout(() => {
				isCopyDone = false;
			}, 2000);
		});
	};

	function handleSelect(event) {
		const addThisJournalist = event.detail
			? event.detail.map((j) => j.value)
			: [];
		config = { ...config, journalists: addThisJournalist };
	}
</script>

<section class="container">
	<h1>Lag en "Hallo 👋"-boks!</h1>
	{#key config}
		<ContactUs {config} />
	{/key}

	<section class="settings">
		<section class="row">
			<section class="column text">
				<h4>Tekster</h4>
				<section>
					<label for="title">Tittel</label>
					<input id="title" bind:value={config.title} />
				</section>
				<section>
					<label for="subtitle">Undertittel</label>
					<input id="subtitle" bind:value={config.subtitle} />
				</section>
				<section>
					<label for="text">Tekst</label>
					<input id="text" bind:value={config.text} />
					{#each config.journalists as journalist, i}
						{#if journalist.text}
							<button
								class="btn-default"
								on:click={() => (config.text = journalist.text)}
								>Bruk {journalist.name.split(" ")[0]}s standardtekst</button
							>
						{/if}
					{/each}
				</section>
				<section>
					<label for="thanks">Hilsen</label>
					<input id="thanks" bind:value={config.thanks} />
				</section>
				<section>
					<div class="checkbox-container">
						<label class="checkbox " for="viewEmail">Vis e-post</label>
						<input
							type="checkbox"
							class="mr"
							id="viewEmail"
							bind:checked={config.viewEmail}
						/>
					</div>
					<div class="checkbox-container">
						<label class="checkbox" for="viewPhone">Vis telefon</label>
						<input
							type="checkbox"
							class="mr"
							id="viewPhone"
							bind:checked={config.viewPhone}
						/>
					</div>
					<div class="checkbox-container">
						<label class="checkbox" for="viewKryptert"
							>Vis "Send kryptert tips"</label
						>
						<input
							type="checkbox"
							class="mr"
							id="viewKryptert"
							bind:checked={config.viewKryptert}
						/>
					</div>
					<div class="checkbox-container">
						<label class="checkbox" for="viewImages">Vis profilbilde</label>
						<input
							type="checkbox"
							class="mr"
							id="viewImages"
							bind:checked={config.viewImages}
						/>
					</div>
				</section>
			</section>
			<section class="column journalists">
				<h4>Journalister</h4>
				<section class="journalists">
					<div class="select-themed">
						{#await allJournalistPromise then allJournalists}
							<label>Klikk under og legg til journalistene du ønsker</label>
							<Select
								items={allJournalists.map((j) => {
									return { label: j.name, value: j };
								})}
								value={config.journalists.map((j) => {
									return { label: j.name, value: j };
								})}
								isMulti={true}
								isSearchable={true}
								isClearable={false}
								noOptionsMessage="Ingen flere valg"
								on:select={handleSelect}
							/>
						{/await}
					</div>
					<label>Fant du ikke journalisten du lette etter? Lag en ny! </label>
					<div class="btn-group">
						<button
							class="btn-default"
							on:click={() =>
								(viewJournalistSettings = !viewJournalistSettings)}
							>{#if viewJournalistSettings}Skjul{:else}Avansert{/if}</button
						>
						<button class="btn-default" on:click={addJournalist}
							>Legg til tom journalist</button
						>
					</div>
					{#if viewJournalistSettings}
						{#each config.journalists as journalist, i (i)}
							<div class="journalist">
								<section>
									<label for="name-{i}">Navn</label>
									<input id="name-{i}" bind:value={journalist.name} />
								</section>
								<section>
									<label for="image-{i}">Bilde</label>
									<input id="image-{i}" bind:value={journalist.image} />
								</section>
								<section>
									<label for="mail-{i}">E-post</label>
									<input id="mail-{i}" bind:value={journalist.email} />
								</section>
								<section>
									<label for="phone-{i}">Telefon</label>
									<input id="phone-{i}" bind:value={journalist.phone} />
								</section>
								<button class="btn-danger" on:click={() => removeJournalist(i)}
									>Fjern journalist</button
								>
							</div>
						{/each}
					{/if}
				</section>
			</section>
		</section>
		<section class="row">
			<section class="column code">
				<h4>Generer kode</h4>
				<p>
					1. Kopier koden ved å klikke på knappen 👉🏼 <button
						class="btn-success"
						on:click={copyCode}
						>{#if isCopyDone}Kopiert!{:else}Kopier kode{/if}</button
					>
					{#if isCopyDone}✅{/if}
				</p>

				<p>
					2. Åpne <a href="https://mm.schibsted.media/dbs" target="_blank"
						>MM-tools</a
					> og lim inn koden der.
				</p>
				<p>3. Klikk på "Lagre" og legg integrasjonen inn i ønsket artikkel.</p>
			</section>
		</section>
	</section>
</section>

<style lang="scss">
	.container {
		max-width: 1000px;
		margin: 0 auto;
	}
	h4 {
		margin: 1rem 0 0.5rem;
	}
	.settings {
		display: flex;
		gap: 16px;
		flex-direction: column;

		.row {
			display: flex;
			flex-direction: row;
			gap: 16px;
			@media screen and (max-width: 481px) {
				flex-direction: column;
			}

			.column {
				&.text,
				&.journalists {
					width: 50%;
					@media screen and (max-width: 481px) {
						width: 100%;
					}
				}
				&.code {
					padding: 0.2rem 0.6rem;
					width: 100%;
					border: 1px solid #ddd;
					border-radius: 6px;
					box-sizing: border-box;
				}
			}
		}
		/* flex-direction: row; */
	}
	section {
		margin: 0 0 4px;
		label {
			font-size: 14px;
			&.checkbox {
				background-color: #fff;
				color: #000;
				padding: 0.3rem 0;
				/* text-align: center; */
				display: inline-block;
				/* font-size: 20px; */
				/* margin: 15px; */

				cursor: pointer;
				&:not(:first-of-type) {
					margin-left: 0.5rem;
				}
			}
		}

		.checkbox-container {
			display: flex;
			align-items: flex-end;
			justify-content: flex-end;
			flex-direction: row-reverse;
			gap: 6px;
		}
		input {
			font-size: 14px;
			width: 100%;
			&[type="checkbox"] {
				width: unset;
			}
		}
	}
	.btn-group {
		display: flex;
		gap: 16px;
		flex-direction: row;
	}
	button {
		margin: 0.3rem 0;
		padding: 0.2rem 0.5rem;
		font-size: 14px;
		border: 1px solid #333;
		border-radius: 4px;
		background: #fff;
		color: #333;
		cursor: pointer;

		&.btn-default {
			color: #333;
			border-color: #333;
			&:hover {
				background: #333;
				color: #fff;
			}
		}

		&.btn-success {
			color: #4caf4f;
			border-color: #4caf4f;
			&:hover {
				background: #4caf4f;
				color: #fff;
			}
		}
		&.btn-danger {
			color: #f44336;
			border-color: #f44336;
			&:hover {
				background: #f44336;
				color: #fff;
			}
		}
	}

	.journalists {
		.journalist {
			margin: 0 0 0.5rem;
		}
		.select-themed {
			margin-bottom: 1rem;
			max-width: 100%;
		}
	}
</style>
